import { HYDRATE } from 'next-redux-wrapper';
import { combineReducers } from 'redux';

import auth from 'app-redux/reducers/authReducer';
import app from 'app-redux/reducers/appReducer';
import appServer from 'app-redux/reducers/appServerReducer';
import page from 'app-redux/reducers/pageReducer';
import { ReducerAction, Store } from 'app-redux/types/storeTypes';
import { IS_CLIENT_SIDE } from 'constants/constants';

const reducers = combineReducers({
  client: combineReducers({ app }),
  server: combineReducers({ auth, page, app: appServer }),
});
const mainReducer = (state: any = {}, action: ReducerAction): Store => {
  if (action.type === HYDRATE) {
    const nextState: Store = {
      client: {
        ...state.client,
        app: {
          ...state.client.app,
          isLoading: false,
          clientWidth: IS_CLIENT_SIDE
            ? document.body.clientWidth
            : 0,
        },
      },
      server: {
        ...state.server,
        ...action.payload.server,
      },
    };

    return nextState;
  }

  return reducers(state, action);
};

export default mainReducer;
